import Joi from 'joi';

import {
  tenantContactCompanyNameRequired,
  tenantContactUpdateIdRule,
  tenantContactWriteFields,
} from '../../../../shared/modules/contacts/validators/schemas/tenant-contact-write-fields.schema';

/**
 * Schema for contact validation belonging to an agent.
 */
export const updateAgentContactSchema = () =>
  Joi.object({
    ...tenantContactUpdateIdRule(),
    ...tenantContactCompanyNameRequired(),
    ...tenantContactWriteFields(),
  }).unknown();
